import state from "./moduleTrackingState.js";
import mutations from "./moduleTrackingMutations.js";
import actions from "./moduleTrackingActions.js";
import getters from "./moduleTrackingGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters
};
